module.exports = __webpack_public_path__ + "9260177dca11c536cb5661025bec46af.svg";